export default __webpack_public_path__ + "static/media/render.2cfe601a.gif";